// mutation types

// Batch search
export const RESET = 'reset'
export const SINGLE_BATCH_SEARCH = 'batchSearch'
export const SINGLE_BATCH_SEARCH_QUERIES = 'batchSearchQueries'
export const BATCH_SEARCHES = 'batchSearches'
export const SELECTED_QUERIES = 'selectedQueries'
export const REMOVE_BATCH_SEARCH = 'removeBatchSearch'
export const CLEAR_BATCH_SEARCH = 'clearBatchSearches'
export const RESULTS = 'results'
export const TOTAL = 'total'
export const NB_BATCH_SEARCHES = 'nbBatchSearches'
